import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { DomSanitizer } from "@angular/platform-browser";
import { Router } from "@angular/router";
import { SharedHttp } from "../../../services/http-client.service";
import { ComponentService } from "../../../services/component.service";
import { LocationStrategy } from "@angular/common";
import { WebsiteThemeService } from "../../../services/website-theme.service";
import { WebClientService } from "../../../services/webclient-settings.service";
import { AuthenticationWalletModalComponent } from "../authentication-wallet-modal/authentication-wallet-modal.component";
import { LimitExceededModalWalletComponent } from "../limit-exceeded-modal-wallet/limit-exceeded-modal-wallet.component";
import { DepositOriginService } from '../../../services/deposit-origin.service';
import { isDepositOriginCode } from '../../../services/deposit-origin';
let BuyBasketWalletModalComponent = class BuyBasketWalletModalComponent {
    constructor(sanitizer, router, httpClient, compService, location, themeService, webSettingsService, depositOriginService) {
        this.sanitizer = sanitizer;
        this.router = router;
        this.httpClient = httpClient;
        this.compService = compService;
        this.location = location;
        this.themeService = themeService;
        this.webSettingsService = webSettingsService;
        this.depositOriginService = depositOriginService;
        this.secondColor = '';
        this.accentColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.errorColor = '';
        this.defaultCurrency = localStorage.getItem('defaultCurrency');
        this.activeCurrency = localStorage.getItem('defaultCurrency').toLowerCase();
        this.chargeFromWalletInput = '';
        this.chargeFromWalletExpanded = false;
        this.step = 1;
        this.errorMessage = '';
        this.limitsExceededMessage = '';
        this.sendButtonClicked = false;
        this.user = JSON.parse(localStorage.getItem('user'));
        this.themeService.getTheme().subscribe((data) => {
            this.secondColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.errorColor = this.themeService.getStyleAttribute('error_color');
        });
        location.onPopState(() => {
            this.close();
        });
    }
    ngOnInit() {
        this.getFiatWallet();
        this.getPrices();
        // a deposit-limit code in the basket list is left to the check before the window opened and to the API:
        // the list is read once, so it still names a statement the user has sent since
        if (this.data.basket.limit_exceeded && !isDepositOriginCode(this.data.basket.limit_exceeded.message)) {
            this.limitsExceededMessage = this.data.basket.limit_exceeded['message'];
        }
        this.intervalId = setInterval(() => {
            if (this.step === 1) {
                this.getPrices();
            }
        }, 15000);
    }
    close() {
        this.modal.destroy();
    }
    ngOnDestroy() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }
    expandChargeFromWallet() {
        this.chargeFromWalletExpanded = !this.chargeFromWalletExpanded;
    }
    fillChargeFromWallet(chargeFromWalletInput, chargeFromWallet) {
        const fiatWalletLanguageValue = this.webSettingsService.getKeyValue('WALLET.WALLET');
        this.chargeFromWalletInput = chargeFromWalletInput + ' ' + fiatWalletLanguageValue;
        this.chargeFromWallet = chargeFromWallet;
    }
    getFiatWallet() {
        for (let i = 0; i < this.data.fiatWallets.length; i++) {
            if (this.data.fiatWallets[i].wallet.currency.verboseId == this.activeCurrency.toUpperCase()) {
                this.fillChargeFromWallet(this.data.fiatWallets[i].wallet.currency.verboseId, this.data.fiatWallets[i].wallet);
                break;
            }
        }
    }
    getPrices() {
        this.httpClient.get('market/pricesforwallet').subscribe((data) => {
            this.data.basket.ecurrency_basket.forEach(ecurrecyBasket => {
                ecurrecyBasket.currencyPrice = Number(data[this.activeCurrency + '_prices'][ecurrecyBasket.ecurrency.code]);
            });
        });
    }
    confirmBuy() {
        this.step = 2;
    }
    buyBasket() {
        this.sendButtonClicked = true;
        if (this.limitsExceededMessage) {
            if (this.user.user_type_id.type === 'lite_verified') {
                this.close();
                this.compService.openModal(LimitExceededModalWalletComponent);
            }
            else {
                this.sendButtonClicked = false;
                this.errorMessage = this.limitsExceededMessage;
            }
        }
        else {
            const buyData = {
                'basket_id': this.data.basket.id,
                'buy_data': []
            };
            this.data.basket.ecurrency_basket.forEach(ecurrecyBasket => {
                var _a, _b;
                buyData['buy_data'].push({
                    walletId: this.chargeFromWallet.verboseId,
                    destinationWalletId: ecurrecyBasket.walletData ? ecurrecyBasket.walletData.verboseId : null,
                    amount: ecurrecyBasket.amountReceive,
                    fiatAmount: ecurrecyBasket.amount,
                    passphrase: ecurrecyBasket.walletData ? ecurrecyBasket.walletData.passphrase : null,
                    cryptocurrency: ecurrecyBasket.ecurrency.code.toUpperCase(),
                    currency: this.chargeFromWallet.currency.verboseId,
                    cryptocurrencyPrice: ecurrecyBasket.currencyPrice,
                    walletAddress: ((_b = (_a = ecurrecyBasket.walletData) === null || _a === void 0 ? void 0 : _a.addresses) === null || _b === void 0 ? void 0 : _b.length) > 0 ? ecurrecyBasket.walletData.addresses.at(-1)['address'] : null
                });
            });
            this.httpClient.post('wallet/basketbuy', buyData).subscribe((data) => {
                this.close();
                this.compService.openModal(AuthenticationWalletModalComponent, {
                    authenticated: true,
                    type: 'internal_buy_basket',
                    isSuccess: true
                });
            }, (error) => {
                if (isDepositOriginCode(error.error.message)) {
                    // the deposit trigger wants the statement or the proof of origin: its window instead of an error
                    this.close();
                    this.depositOriginService.openForCode(error.error.message);
                    return;
                }
                this.errorMessage = error.error['message'];
                this.sendButtonClicked = false;
            });
        }
    }
};
BuyBasketWalletModalComponent.ctorParameters = () => [
    { type: DomSanitizer },
    { type: Router },
    { type: SharedHttp },
    { type: ComponentService },
    { type: LocationStrategy },
    { type: WebsiteThemeService },
    { type: WebClientService },
    { type: DepositOriginService }
];
BuyBasketWalletModalComponent = __decorate([
    Component({
        selector: 'ecd-buy-basket-wallet-modal',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./buy-basket-wallet-modal.component.html")).default,
    })
], BuyBasketWalletModalComponent);
export { BuyBasketWalletModalComponent };
